<template>
  <div :style="`min-height:${contentHeight}px`" class="position-relative">
    <div :style="`min-height:${contentHeight / 2}px`">
      <div>
        <div class="d-flex align-items-center">
          <span style="font-size: 14px; color: #606266">{{ '图片' }}</span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <div>
            <el-upload
              :ref="`Uploader-${uploadId}`"
              :name="uploadId"
              action="/oss/ossUploadReturnUrlAndFileId"
              :file-list="listImageFile"
              :show-file-list="false"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed"
              :on-change="onImageChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <el-button class="ml-2" style="font-size: 14px;" type="text">
                上传图片</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap block">
        <!-- <vuedraggable
          @end="draggableEnd"
          tag="div"
          draggable=".draggable-item"
          class="d-flex flex-wrap"
        > -->
        <div
          v-for="(item, index) in listImageView"
          :key="index"
          class="draggable-item"
        >
          <div class="image-box">
            <span class="default-icon" v-if="listImage[index].isDefaultImage">
              <i class="el-icon-success"></i>
            </span>
            <el-image
              style="width: 100%; height: 100%"
              fit="scale-down"
              :src="item"
              :preview-src-list="listImageView"
            ></el-image>
            <div
              class="shadow d-flex align-items-center justify-content-center"
            >
              <div>
                <span @click="onImagePreview(index)">
                  <i class="el-icon-zoom-in"></i
                ></span>
                <!-- <span
                      v-if="!disabled"
                      @click="onImageCheck(index)"
                      class="ml-2"
                    >
                      <i class="el-icon-check"></i
                    ></span> -->
                <span @click="onImageDel(index)" class="ml-2">
                  <i class="el-icon-delete-solid"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- </vuedraggable> -->
      </div>
      <div
        class="position-absolute"
        style="text-align: center;top: 40%;left: 40%;"
        v-if="!listImageView || !listImageView.length"
      >
        <img src="/image/static/img/nodata.png" />
        <p class="no-data">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImage"
        :src="item.originImageUrl || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
// import vuedraggable from 'vuedraggable'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],

  props: {
    orderCode: { type: String, default: '' },
    techCuttingCode: { type: String, default: '' },
    techCuttingDetailCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  // components: { vuedraggable },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadId: Math.random()
        .toString(36)
        .substr(2)
        .toLocaleUpperCase(),
      fileTotal: 0, //上传文件总数
    }
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 300
    },
    listImageView() {
      return this.listImage.map((image) => {
        return image.thumbImageUrl
      })
    },
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length
    },
  },

  mounted() {
    this.loadImages()
  },
  methods: {
    async loadImages() {
      this.listImage = []
      this.listImage = await this.getImageData(this.techCuttingDetailCode)
    },
    async getImageData(techCuttingDetailCode) {
      if (!techCuttingDetailCode) return []
      return await this.$api
        .techCuttingImageListApi({ techCuttingDetailCode })
        .then((res) => res.body.data)
    },
    onImagePreview(index) {
      // 点击大图显示图片预览组件
      if (this.listImage.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    onImageDel(index) {
      const image = this.listImage[index]
      const params = {
        techCuttingImageCode: image.techCuttingImageCode,
        techCuttingDetailCode: this.techCuttingDetailCode,
      }
      this.loadingOpen()
      this.$api
        .techCuttingImageDelApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.loadImages()
          } else {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        })
    },
    // onImageCheck(index) {
    //   const image = this.listImage[index]
    //   const params = {
    //     techCuttingDetailCode: this.techCuttingDetailCode,
    //     sampleImgCode: image.sampleImgCode,
    //   }

    //   this.loadingOpen()
    //   this.setSampleDefaultImage(params)
    //     .then((res) => {
    //       this.loadingClose()
    //       const { status } = res
    //       if (status === 200) {
    //         this.$message({
    //           showClose: true,
    //           message: this.$l('INDEX.tips_set_ok') || '设置成功！',
    //           type: 'success',
    //         })
    //         this.loadImages()
    //       } else {
    //         this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
    //       }
    //     })
    //     .catch(() => {
    //       this.loadingClose()
    //       this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
    //     })
    // },
    // async setSampleDefaultImage(params) {
    //   return await this.$api.setsampleInfoDefaultImageApi(params)
    // },

    onImageChange(file, fileList) {
      //获取添加文件进来的状态
      file.status == 'ready' && this.listImageFile.push(file)
      //获取原始文件的个数
      this.fileTotal = document.getElementsByName(this.uploadId)[0].files.length

      //如果原始文件和upload的个数相同的时候就说明已经添加完了，可以触发上传的方法了
      if (this.listImageFile.length === this.fileTotal) {
        // if (this.fileTotal > 1) {
        //   this.$message.warning(
        //     `当前限制选择 1 张图片，本次选择了 ${this.fileTotal} 张图片`
        //   )
        //   const Uploader = this.$refs[`Uploader-${this.uploadId}`]
        //   Uploader.clearFiles()
        //   this.listImageFile = []
        //   return
        // }
        this.upload()
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (newIndex === oldIndex) return
      const oldEl = { ...this.listImage[oldIndex] }
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listImage[i] = this.listImage[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = newIndex; i < oldIndex; i++) {
          this.listImage[i] = this.listImage[i + 1]
        }
      }
      this.listImage[newIndex] = oldEl
    },
    uploadImages() {
      if (this.isEmpty) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImageFile.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          originImageCode: res.body.fileId,
          originImageUrl: res.body.url,
          originImageSpec: image.raw.type,
          thumbImageCode: res.body.thumbnailFileId,
          thumbImageUrl: res.body.thumbnailUrl,
          uid: image.uid,
        }))
      })
      return Promise.all(uploadTask)
    },
    async upload() {
      if (this.isEmpty) {
        this.$message.warning(
          this.$l('pe_select_upload_image') || '请选择您需要上传的图片！'
        )
        return
      }
      this.listImageFile = await this.uploadImages()
      const params = {
        orderCode: this.orderCode,
        techCuttingCode: this.techCuttingCode,
        techCuttingDetailCode: this.techCuttingDetailCode,
        listImage: this.listImageFile,
      }
      this.loadingOpen()
      this.uploadInfoSave(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.loadImages()
          } else {
            this.$message.error(
              this.$l('INDEX.uploader_label_status_error') || '上传失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
      //获取上传文件的组件
      const Uploader = this.$refs[`Uploader-${this.uploadId}`]
      Uploader.clearFiles()
      this.listImageFile = []
    },
    async uploadInfoSave(params) {
      return await this.$api.techCuttingImageSaveApi(params)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.el-upload-list__item.is-ready {
  display: none;
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
